import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.709 12.16c-.54-1.232-1.54-2.54-2.387-3.002.693 1.308 1.078 2.617 1.232 3.618-1.309-3.31-3.618-4.696-5.465-7.621a1.612 1.612 0 0 0-.308-.462c-.077-.077-.077-.154-.154-.231-.077-.154-.154-.308-.154-.462-2.617 1.54-3.695 4.234-4.003 5.927-.847.077-1.617.231-2.31.616-.153.077-.23.231-.153.385.077.154.23.231.384.154.616-.308 1.31-.462 2.079-.539h.385c.539 0 1.154.077 1.693.231h.077c.077 0 .154.077.308.077.077 0 .154.077.231.077.077 0 .077.077.154.077s.154.077.231.154l.077.077c.077.077.154.077.23.154.078 0 .078.077.155.077a6.206 6.206 0 0 1 2.078 2.155c-.615-.461-1.77-.846-2.848-.692 4.234 2.155 3.08 9.468-2.771 9.16-.539 0-1.078-.154-1.54-.308-.154-.077-.23-.077-.385-.154-.077 0-.154-.077-.23-.077-1.463-.77-2.618-2.155-2.772-3.849 0 0 .539-2.001 3.926-2.001.385 0 1.386-1 1.386-1.309 0-.077-2.079-.924-2.848-1.693-.462-.385-.616-.616-.847-.77-.077-.077-.231-.154-.308-.231-.231-.924-.308-1.925 0-2.925-1.232.462-2.233 1.308-2.925 2.078-.462-.616-.385-2.54-.385-2.925 0 0-.385.154-.385.23a6.812 6.812 0 0 0-1.155.925c-.385.384-.77.846-1.078 1.308a10.523 10.523 0 0 0-1.616 3.541s-.077.462-.154 1.078c0 .077 0 .154-.077.308 0 .23-.077.462-.077.693v.462c0 6.62 5.235 11.854 11.778 11.854 5.85 0 10.7-4.233 11.624-9.853 0-.154 0-.308.076-.462.231-1.924 0-4.08-.77-5.85Z",
    fill: "currentColor"
  }));
};

var SvgFirefox = styled(SvgComponent).withConfig({
  displayName: "Firefox__SvgFirefox",
  componentId: "sc-y68yvm-0"
})(["", " ", ""], size, color);
export default SvgFirefox;